var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "section section--notfound" }, [
      _c("div", { staticClass: "section__inner-wrapper" }, [
        _c("div", { staticClass: "c-notfound" }, [
          _c("div", { staticClass: "c-notfound__col" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "251",
                  viewBox: "0 0 251 265",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("circle", {
                  attrs: { cx: "125.5", cy: "139.5", r: "125.5", fill: "#fff" }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "M130.465 29.454c8.122 0 14.728-6.605 14.728-14.727S138.587 0 130.465 0s-14.727 6.605-14.727 14.727 6.605 14.727 14.727 14.727zm0-22.09c4.061 0 7.364 3.302 7.364 7.363s-3.303 7.364-7.364 7.364-7.363-3.303-7.363-7.364c0-4.06 3.302-7.363 7.363-7.363z",
                    fill: "#363472"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "M204.1 88.363c0-7.272-5.305-13.288-12.241-14.477-2.637-7.72-9.422-13.512-17.692-14.72 3.866-2.731 6.676-6.862 7.548-11.697 6.495-1.531 11.34-7.378 11.34-14.333 0-8.122-6.605-14.727-14.727-14.727-5.442 0-10.202 2.968-12.75 7.364h-1.977c-10.151 0-18.409 8.258-18.409 18.409 0 8.6 5.953 15.783 13.939 17.797-3.671 2.029-6.653 4.927-8.435 8.284-2.198-3.987-6.156-6.844-10.843-7.496 1.046-2.308 1.657-4.849 1.657-7.54 0-10.15-8.258-18.41-18.409-18.41-7.154 0-13.313 4.132-16.358 10.107-3.292-8.074-11.215-13.788-20.46-13.788-1.852 0-3.638.254-5.357.685-2.445-4.757-7.345-8.048-13.052-8.048-8.122 0-14.727 6.605-14.727 14.727 0 6.852 4.724 12.577 11.071 14.211-.004.174-.026.343-.026.516 0 12.183 9.908 22.09 22.091 22.09 3.59 0 7.043-.85 10.162-2.473 2.677 3.71 7.01 6.155 11.929 6.155 5.442 0 10.202-2.967 12.75-7.363h1.977c.184 0 .357-.048.541-.055-.32 1.2-.541 2.437-.541 3.737 0 5.441 2.968 10.202 7.364 12.75v1.977c0 1.259.128 2.492.371 3.682h-26.475c-1.76-10.43-10.832-18.41-21.76-18.41-5.184 0-9.948 1.808-13.722 4.81-2.691-2.876-7.128-4.81-12.05-4.81-8.122 0-14.727 6.606-14.727 14.728 0 5.806 3.402 10.787 8.295 13.184a15.427 15.427 0 00-.932 5.225c0 .18.015.361.04.537l14.691 99.169c.225 8.527 9.9 18.111 18.405 18.111h81c8.505 0 18.18-9.584 18.405-18.111l14.69-99.169c.026-.176.041-.357.041-.537 0-3.152-.854-5.979-2.353-8.299 5.652-2.062 9.716-7.437 9.716-13.792zm-51.545-44.181c0-6.09 4.956-11.046 11.046-11.046h7.363c0-4.06 3.303-7.364 7.364-7.364s7.364 3.303 7.364 7.364-3.303 7.364-7.364 7.364h-3.682v3.681c0 6.09-4.956 11.046-11.045 11.046-6.09 0-11.046-4.956-11.046-11.045zm-86.93 3.291c-2.957-.957-5.114-3.704-5.114-6.973 0-4.061 3.302-7.364 7.363-7.364 2.692 0 5.026 1.47 6.31 3.63a22.156 22.156 0 00-8.56 10.707zm20.658 22.481c-8.122 0-14.727-6.605-14.727-14.727S78.16 40.5 86.283 40.5c7.58 0 13.77 5.776 14.569 13.147-4.304 2.578-7.205 7.257-7.205 12.625 0 .538.103 1.046.158 1.569-2.272 1.362-4.83 2.113-7.522 2.113zm29.454-3.682c0 4.061-3.302 7.364-7.363 7.364s-7.364-3.303-7.364-7.364c0-4.06 3.303-7.363 7.364-7.363h3.682v-3.682c0-6.09 4.955-11.045 11.045-11.045s11.045 4.955 11.045 11.045-4.955 11.045-11.045 11.045h-7.364zm22.091 3.682c4.061 0 7.364 3.303 7.364 7.364v3.681h3.682c6.089 0 11.045 4.956 11.045 11.046 0 6.09-4.956 11.045-11.045 11.045-6.09 0-11.046-4.956-11.046-11.045V84.68c-4.061 0-7.363-3.302-7.363-7.363s3.302-7.364 7.363-7.364zM82.601 84.681c6.845 0 12.559 4.71 14.205 11.046h-28.41c1.647-6.337 7.36-11.046 14.205-11.046zm-25.772 0c3.73 0 6.303 1.767 7.087 2.997a21.9 21.9 0 00-3.126 8.395c-2.411.508-4.41 1.594-6.07 2.99-3.027-.914-5.255-3.697-5.255-7.018 0-4.061 3.303-7.364 7.364-7.364zm117.858 124.644a3.691 3.691 0 00-.041.537c0 4.44-6.605 11.046-11.045 11.046h-81c-4.44 0-11.045-6.606-11.045-11.046 0-.18-.015-.361-.04-.537l-14.684-99.111c.093-2.599 1.716-7.124 7.36-7.124h69.954c.03 0 .052-.015.081-.015 3.362 4.452 8.649 7.379 14.647 7.379 5.997 0 11.284-2.927 14.646-7.379.029 0 .051.015.081.015h18.409c4.388 0 7.257 2.784 7.36 7.113l-14.683 99.122zm14.686-113.598c-4.061 0-7.363-3.303-7.363-7.364h-7.364c0 2.297.574 4.444 1.517 6.384-1.649.626-3.391.98-5.199.98h-4.053c.243-1.19.372-2.423.372-3.682 0-7.408-4.433-13.748-10.755-16.668 1.344-4.558 7.176-9.105 14.436-9.105 8.122 0 14.728 6.605 14.728 14.727h3.681c4.061 0 7.364 3.303 7.364 7.364s-3.303 7.364-7.364 7.364z",
                    fill: "#363472"
                  }
                }),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M159.92 158.317c0 20.334-16.484 36.818-36.818 36.818-20.334 0-36.818-16.484-36.818-36.818 0-20.334 16.484-36.818 36.818-36.818 20.334 0 36.818 16.484 36.818 36.818zm-62.59 0c0-14.208 11.564-25.773 25.772-25.773 14.208 0 25.772 11.565 25.772 25.773s-11.564 25.773-25.772 25.773c-14.208 0-25.773-11.565-25.773-25.773zm7.363 0c0 10.151 8.258 18.409 18.409 18.409 10.15 0 18.409-8.258 18.409-18.409s-8.259-18.409-18.409-18.409c-10.151 0-18.409 8.258-18.409 18.409z",
                    fill: "#FF7043"
                  }
                }),
                _c("path", {
                  attrs: {
                    d:
                      "M163.601 206.18h-11.045v7.364h11.045v-7.364zM145.191 206.18h-25.773v7.364h25.773v-7.364zM82.6 55.227h-7.363c0 6.09 4.956 11.045 11.046 11.045V58.91a3.683 3.683 0 01-3.682-3.682z",
                    fill: "#363472"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-notfound__col" }, [
      _c("h2", { staticClass: "c-notfound__title" }, [_vm._v("404")]),
      _vm._v(" "),
      _c("p", { staticClass: "c-notfound__text" }, [
        _vm._v("Oop! We cant find movie that you are looking for")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "c-btn c-btn--buy", attrs: { href: "/" } }, [
        _vm._v("Go to Home")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }